let subscribers = {};

// Maximum subscribers per event to prevent memory leaks from uncleared subscriptions
const MAX_SUBSCRIBERS_PER_EVENT = 100;

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  // Check for duplicate subscriptions to prevent accidental memory growth
  if (subscribers[eventName].includes(callback)) {
    console.warn(`[PubSub] Duplicate subscription prevented for "${eventName}"`);
    return function unsubscribe() {
      subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
    };
  }

  // Warn and evict oldest if at capacity (likely indicates a memory leak)
  if (subscribers[eventName].length >= MAX_SUBSCRIBERS_PER_EVENT) {
    console.warn(`[PubSub] Max subscribers (${MAX_SUBSCRIBERS_PER_EVENT}) reached for "${eventName}". Removing oldest subscription.`);
    subscribers[eventName].shift();
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
